<template>
    <div class="card">
        <div class="card-header p-4">Detail Pegawai</div>
        <div class="card-body">
            <table class="table table-bordered table-striped">
                <tr>
                    <th>NIP:</th>
                    <td><span v-html="employee.employee_nip"></span></td>
                </tr>
                <tr>
                    <th>NIK:</th>
                    <td><span v-html="employee.employee_nik"></span></td>
                </tr>
                <tr>
                    <th>Nama:</th>
                    <td><span v-html="employee.employee_name"></span></td>
                </tr>
                <tr>
                    <th>Jabatan:</th>
                    <td><span v-html="position"></span></td>
                </tr>
                <tr>
                    <th>E-Mail:</th>
                    <td><span v-html="employee.employee_email"></span></td>
                </tr>
                <tr>
                    <th>No HP:</th>
                    <td><span v-html="employee.employee_phone"></span></td>
                </tr>
                <tr>
                    <th>Jenis Kelamin:</th>
                    <td><span v-html="employee.employee_gender"></span></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'EmployeInfo',
        props: {
            employee: {
                type: Object,
                default: () => ({
                    employee_id: null,
                    employee_nip: null,
                    employee_name: null,
                    position: null
                })
            }
        },
        computed: {
            position() {
                if (!this.employee.position) return '-'
                return this.employee.position.position_name
            }
        }
    }
</script>
s
